/**
 * @generated SignedSource<<d811690741f151e0818e408c9e058738>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiStudioContentToolScopeStatusQuery$variables = Record<PropertyKey, never>;
export type aiStudioContentToolScopeStatusQuery$data = {
  readonly aiStudio3DModelScopeStatus: {
    readonly isDisabled: boolean;
  };
  readonly aiStudioImageScopeStatus: {
    readonly isDisabled: boolean;
  };
  readonly aiStudioUpscalerScopeStatus: {
    readonly isDisabled: boolean;
  };
  readonly aiStudioVideoScopeStatus: {
    readonly isDisabled: boolean;
  };
};
export type aiStudioContentToolScopeStatusQuery = {
  response: aiStudioContentToolScopeStatusQuery$data;
  variables: aiStudioContentToolScopeStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDisabled",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": "aiStudioImageScopeStatus",
    "args": [
      {
        "kind": "Literal",
        "name": "scope",
        "value": "AI_STUDIO_IMAGE"
      }
    ],
    "concreteType": "AIToolScopeStatus",
    "kind": "LinkedField",
    "name": "aiToolScopeStatus",
    "plural": false,
    "selections": (v0/*:: as any*/),
    "storageKey": "aiToolScopeStatus(scope:\"AI_STUDIO_IMAGE\")"
  },
  {
    "alias": "aiStudioVideoScopeStatus",
    "args": [
      {
        "kind": "Literal",
        "name": "scope",
        "value": "AI_STUDIO_VIDEO"
      }
    ],
    "concreteType": "AIToolScopeStatus",
    "kind": "LinkedField",
    "name": "aiToolScopeStatus",
    "plural": false,
    "selections": (v0/*:: as any*/),
    "storageKey": "aiToolScopeStatus(scope:\"AI_STUDIO_VIDEO\")"
  },
  {
    "alias": "aiStudioUpscalerScopeStatus",
    "args": [
      {
        "kind": "Literal",
        "name": "scope",
        "value": "AI_STUDIO_UPSCALER"
      }
    ],
    "concreteType": "AIToolScopeStatus",
    "kind": "LinkedField",
    "name": "aiToolScopeStatus",
    "plural": false,
    "selections": (v0/*:: as any*/),
    "storageKey": "aiToolScopeStatus(scope:\"AI_STUDIO_UPSCALER\")"
  },
  {
    "alias": "aiStudio3DModelScopeStatus",
    "args": [
      {
        "kind": "Literal",
        "name": "scope",
        "value": "AI_STUDIO_3D_MODEL"
      }
    ],
    "concreteType": "AIToolScopeStatus",
    "kind": "LinkedField",
    "name": "aiToolScopeStatus",
    "plural": false,
    "selections": (v0/*:: as any*/),
    "storageKey": "aiToolScopeStatus(scope:\"AI_STUDIO_3D_MODEL\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiStudioContentToolScopeStatusQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiStudioContentToolScopeStatusQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "85d91460efca351b0711d2a5bc58dcba",
    "id": null,
    "metadata": {},
    "name": "aiStudioContentToolScopeStatusQuery",
    "operationKind": "query",
    "text": "query aiStudioContentToolScopeStatusQuery {\n  aiStudioImageScopeStatus: aiToolScopeStatus(scope: AI_STUDIO_IMAGE) {\n    isDisabled\n  }\n  aiStudioVideoScopeStatus: aiToolScopeStatus(scope: AI_STUDIO_VIDEO) {\n    isDisabled\n  }\n  aiStudioUpscalerScopeStatus: aiToolScopeStatus(scope: AI_STUDIO_UPSCALER) {\n    isDisabled\n  }\n  aiStudio3DModelScopeStatus: aiToolScopeStatus(scope: AI_STUDIO_3D_MODEL) {\n    isDisabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd5f91e44cb0a7b9bb85793a9b692369";

export default node;
